import React from 'react';
import './styles.scss';
import { Link } from 'gatsby';

class Footer extends React.Component {
    render() {
        return (
            <>
                <div className='footerCtr'>
                    <div className='leaderImage'>
                        <img
                            src={'https://sw-assets.gumlet.io/trivia/misc/leader.png?blur=30'}
                            data-src={'https://sw-assets.gumlet.io/trivia/misc/leader.png'}
                            alt={'Leader'}
                        />
                    </div>
                    <div className='logo'>
                        <img
                            src={'https://sw-assets.gumlet.io/trivia/logos/trivia-sw-logo.svg'}
                            data-src={'https://sw-assets.gumlet.io/trivia/logos/trivia-sw-logo.svg'}
                            alt={'Trivia logo'}
                        />
                    </div>
                    <div className='logo-mob'>
                        <img
                            src={'https://sw-assets.gumlet.io/trivia/misc/leader-mob.svg?blur=30'}
                            data-src={'https://sw-assets.gumlet.io/trivia/misc/leader-mob.svg'}
                            alt='Trivia logo'
                        />
                    </div>
                    <div className='footerLinks'>
                        <div className='informationCtrLink'>
                            <h6>Information</h6>
                            <Link to={'/trivia/'}>Trivia</Link>
                            <Link to={'/trivia/pricing/'}>Pricing</Link>
                            <Link to={'/trivia/customers/'}>Success Stories</Link>
                            <a href={'/cookie-policy/'} target='_blank' rel='noreferrer noopener'>
                                Cookies Policy
                            </a>
                            <a href={'/privacy-policy/'} target='_blank' rel='noreferrer noopener'>
                                Privacy Policy
                            </a>
                            <a href={'/tnc/'} target='_blank' rel='noreferrer noopener'>
                                Terms & Conditions
                            </a>
                            <a href='mailto:press@springworks.in/'>Press Enquiries</a>
                            <Link to='/'>Back to Springworks </Link>
                            <Link to={'/trivia/security/'}>Security</Link>
                            <a href={'/gdpr/'} target='_blank' rel='noreferrer noopener'>
                                GDPR
                            </a>
                        </div>

                        <div className='informationCtrLink'>
                            <h6>Resources</h6>
                            <a
                                href='https://www.springworks.in/blog/category/trivia/'
                                target='_blank'
                                rel='noreferrer noopener'
                            >
                                Blog
                            </a>
                            <a
                                href='https://www.notion.so/Trivia-Road-Map-030b020adaeb40f79547faedda3ddbda/'
                                target='_blank'
                                rel='noreferrer noopener'
                            >
                                Timeline
                            </a>
                            <a
                                href='https://support.springworks.in/portal/en/kb/trivia'
                                target='_blank'
                                rel='noreferrer noopener'
                            >
                                User Guide
                            </a>
                            <a
                                href='https://springworks.tawk.help/category/trivia-knowledge-base/support-videos'
                                target='_blank'
                                rel='noreferrer noopener'
                            >
                                Videos
                            </a>
                            <Link to={'https://support.springworks.in/portal/en/kb/trivia'}>FAQ</Link>
                        </div>
                        <div className='informationCtrLink'>
                            <h6>Features</h6>
                            <Link to={'/trivia/virtual-water-cooler/'}>Virtual Water Cooler </Link>
                            <Link to={'/trivia/pictionary-online/'}>Pictionary </Link>
                            <Link to={'/trivia/games/'}>Games</Link>
                            <Link to={'/trivia/internal-branding/'}>Internal Branding Quizzes</Link>
                            <Link to={'/trivia/virtual-coffee/'}>VirtualCoffee</Link>
                        </div>
                        <div className='informationCtrLink'>
                            <h6>Platforms</h6>
                            <Link to={'/trivia/slack/'}>Trivia for Slack</Link>
                            <Link to={'/trivia/microsoft-teams/'}>Trivia for Microsoft Teams</Link>
                        </div>
                        <div className='informationCtrLink'>
                            <h6>Customer Service</h6>
                            <span role={'link'} tabIndex={'0'} onKeyDown={() => {}} onClick={() => {}}>
                                Contact Us
                            </span>

                            <div className='informationCtrLink officeAddress'>
                                <h6>Office</h6>
                                <p>1447 2nd Street, Suite 200 Santa Monica, CA 90401 United States</p>
                            </div>
                        </div>
                    </div>
                    <div className='mobTSocialMedia'>
                        <h4>Follow us</h4>
                        <div className='tSocialMedia'>
                            <div className='tSocialMediaIcons'>
                                <a
                                    className='tSocialMediaIcon'
                                    target='_blank'
                                    rel='noreferrer noopener'
                                    href='https://twitter.com/springroleinc?s=20/'
                                >
                                    <img
                                        src={'https://sw-assets.gumlet.io/common/twitter.svg'}
                                        data-src={'https://sw-assets.gumlet.io/common/twitter.svg'}
                                        alt={'twitter'}
                                    />
                                </a>
                                <a
                                    className='tSocialMediaIcon'
                                    target='_blank'
                                    rel='noreferrer noopener'
                                    href='https://linkedin.com/company/springrole/'
                                >
                                    <img
                                        src={'https://sw-assets.gumlet.io/common/linkedin.svg'}
                                        data-src={'https://sw-assets.gumlet.io/common/linkedin.svg'}
                                        alt={'linked'}
                                        placeholder={'tracedSVG'}
                                    />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='innerCtrFooter'>
                    <div className='subscriptionCtr'>
                        <div className='title'>{'Subscribe to Springworks '}</div>
                        <div className='subTitle'>
                            Exclusive invites to webinars, highly curated eBooks and access to content for remote work
                            resources picked up by our editor
                        </div>
                        <form
                            action='https://springworks.us14.list-manage.com/subscribe?u=ca6975e5d8eb9feae8b42d901&id=d29f51722f'
                            method='post'
                            id='mc-embedded-subscribe-form'
                            name='mc-embedded-subscribe-form'
                            className='emailCtr'
                            target='_blank'
                            rel='noreferrer noopener'
                            noValidate
                        >
                            <div id='mc_embed_signup_scroll' className='d-flex justify-content-start'>
                                <input
                                    className='emailInput'
                                    name='EMAIL'
                                    type={'email'}
                                    id='mce-EMAIL'
                                    placeholder={'Email Address'}
                                    required
                                />
                                <div className='clear'>
                                    <input
                                        type='submit'
                                        value='SUBSCRIBE'
                                        name='subscribe'
                                        id='mc-embedded-subscribe'
                                        className='button'
                                    />
                                </div>
                            </div>
                        </form>
                        <div className='mob-trivia-logo'>
                            <img
                                src={'https://sw-assets.gumlet.io/trivia/logos/trivia-sw-logo.svg'}
                                data-src={'https://sw-assets.gumlet.io/trivia/logos/trivia-sw-logo.svg'}
                                alt={'Trivia logo'}
                            />
                        </div>
                    </div>

                    <div className='tSocialMediaWrap'>
                        <span className='tSocialMediaHeader'>
                            <h4>Follow Us</h4>
                        </span>
                        <div className='tSocialMedia'>
                            <div className='tSocialMediaIcons'>
                                <a
                                    href='https://instagram.com/lifeatspringworks/'
                                    target='_blank'
                                    rel='noreferrer noopener'
                                    className='tSocialMediaIcon'
                                >
                                    <img
                                        src={'https://sw-assets.gumlet.io/common/instagram.svg'}
                                        data-src={'https://sw-assets.gumlet.io/common/instagram.svg'}
                                        alt={'instagram'}
                                    />
                                </a>
                                <a
                                    className='tSocialMediaIcon'
                                    target='_blank'
                                    rel='noreferrer noopener'
                                    href='https://twitter.com/springroleinc?s=20/'
                                >
                                    <img
                                        src={'https://sw-assets.gumlet.io/common/twitter.svg'}
                                        data-src={'https://sw-assets.gumlet.io/common/twitter.svg'}
                                        alt={'twitter'}
                                    />
                                </a>
                                <a
                                    className='tSocialMediaIcon'
                                    target='_blank'
                                    rel='noreferrer noopener'
                                    href='https://facebook.com/springrole/'
                                >
                                    <img
                                        src={'https://sw-assets.gumlet.io/common/facebook.svg'}
                                        data-src={'https://sw-assets.gumlet.io/common/facebook.svg'}
                                        alt={'facebook'}
                                    />
                                </a>
                                <a
                                    className='tSocialMediaIcon'
                                    target='_blank'
                                    rel='noreferrer noopener'
                                    href='https://linkedin.com/company/springrole/'
                                >
                                    <img
                                        src={'https://sw-assets.gumlet.io/common/linkedin.svg'}
                                        data-src={'https://sw-assets.gumlet.io/common/linkedin.svg'}
                                        alt={'linkedin'}
                                    />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default Footer;
